import { QuestionOption } from '../../../../common/enums/QuestionOption';

export const getDefaultIntl = (o: QuestionOption) => {
  switch (o) {
    case QuestionOption.Yes:
      return 'yes';
    case QuestionOption.No:
      return 'no';
    case QuestionOption.IDontKnow:
      return 'iDontKnow';
    case QuestionOption.RarelyOrNever:
      return 'survey.rarelyOrNever';
    case QuestionOption.Sometimes:
      return 'survey.sometimes';
    case QuestionOption.Often:
      return 'survey.often';
    case QuestionOption.Usually:
      return 'survey.usually';
    case QuestionOption.AlmostAlways:
      return 'survey.almostAlways';
    default:
      return '';
  }
};

export const getDefaultMessage = (o: QuestionOption) => {
  switch (o) {
    case QuestionOption.Yes:
      return 'Yes';
    case QuestionOption.No:
      return 'No';
    case QuestionOption.IDontKnow:
      return 'I don\'t know';
    case QuestionOption.RarelyOrNever:
      return 'Rarely / Never';
    case QuestionOption.Sometimes:
      return 'Sometimes';
    case QuestionOption.Often:
      return 'Often';
    case QuestionOption.Usually:
      return 'Usually';
    case QuestionOption.AlmostAlways:
      return 'Almost always';
    default:
      return '';
  }
};
